<template>
  <v-form v-model="valid" ref="form" lazy-validation>
    <v-layout row wrap>
      <v-flex xs12 v-if="!isMakerlab">
        <h2 class="mb-1">Adicione Solicitação de evidência</h2>

        <v-btn color="primary" @click="adicionar">Adicionar</v-btn>
        <v-dialog id="dialog" v-model="dialog" max-width="100%" persistent>
          <v-card>
            <v-card-title>
              <h1>Nova Solicitação</h1>
            </v-card-title>
            <v-card-text>
              <v-text-field
                label="Titulo da solicitação"
                ref="obs"
                hint="Nome da habilidade que será mostrada para o aluno"
                v-model="tarefatitulo"
              ></v-text-field>
              <v-text-field
                label="Descrição da solitação"
                hint="Descrição para o aluno de como realizar a evidência"
                v-model="tarefadescricao"
              ></v-text-field>
            </v-card-text>
            <v-card-actions>
              <input-criterios-aval
                style="width: 100%"
                :criterios="habilidades"
                :titulo="titulo"
                :clear="clear"
                :btnedit="btnedit"
                :editHabil="editHabil"
                :solicitacao="solicitacao"
                @saved="criteriosSelecionados"
                @edit="editAtual"
                @cancel="closeDialog"
              ></input-criterios-aval>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-flex>
      <v-flex style="widht: 100 %" xs12 class="mt-3">
        <div v-if="!dialog">
          <h3>Solicitações :</h3>
          <v-expansion-panel
            style="width: 100%"
            class="mt-2"
            v-for="(tarefas, index) in salvandoCriterio"
            :key="tarefas.obrigatorias"
          >
            <v-expansion-panel-content>
              <div slot="header">{{tarefas.title}}</div>
              <v-card raised tile>
                <v-card-title>
                  <h2 style="text-align: center;" align-content-center>{{tarefas.title}}</h2>
                </v-card-title>
                <v-card-text>
                  <strong>Descrição:</strong>
                  {{tarefas.description}}
                </v-card-text>
                <show-criterio
                  style="width: 100%"
                  :criterios="tarefas.habilidades"
                  :titulo="false"
                  :solicitacao="false"
                  :botaosaved="false"
                  :btnedit="false"
                  :makerlab="makerLab"
                ></show-criterio>
                <v-btn
                  color="primary"
                  flat
                  v-if="!makerLab"
                  @click.stop="editarSolicitacao(tarefas, index)"
                >Editar solicitacao</v-btn>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-spacer></v-spacer>
        <v-layout align-center justify-end row fill-height>
          <div class="mt-5">
            <v-btn color="primary" @click.native="$emit('prev')">voltar</v-btn>
            <v-btn color="primary" @click.native="proximo">Continuar</v-btn>
          </div>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-form>
</template>

<script>
// import api from '@/api'
import InputCriteriosAval from '@/components/reusable/inputCriteriosAval.vue';
import ShowCriterio from '@/components/reusable/showCriterio.vue';
export default {
  components: {
    InputCriteriosAval,
    ShowCriterio
  },
  props: ['criterios', 'dialog_criterios', 'tarefasModel', 'step3Data', 'cont'],
  data () {
    return {
      result: {},
      tabela: false,
      habilidades: [],
      tarefatitulo: '',
      tarefadescricao: '',
      tarefaData: '',
      tarefas_obrigatorias: '',
      show: false,
      salvandoCriterio: [],
      editHabil: [],
      ident: '',
      clear: true,
      solicitacao: true,
      i: 0,
      dialog: false,
      btnedit: false,
      options: {},
      valid: true,
      titulo: true,
      menu: false,
      makerLab: false
    };
  },
  mounted () {
    this.$watch('tarefasModel', function () {
      if (this.tarefasModel.length !== null) {
        this.tarefasList();
      }
    });
    this.$watch('cont', function () {
      console.log('watch step3', this.step3Data);
      this.pickHabilidade(this.step3Data);
    })

    this.makerLab = this.$store.state.company.makerlab
  },
  computed: {
    isMakerlab () {
      return this.$store.state.company.makerlab;
    },
    tarefasList () {
      this.salvandoCriterio = this.tarefasModel;
      this.i = this.salvandoCriterio.length;
    },
    computedDateFormatted2 () {
      return this.formatDate(this.tarefaData);
    }
  },
  methods: {
    proximo () {
      if (this.$refs.form.validate()) {
        this.$emit('dados4', this.salvandoCriterio);
        this.$emit('dadotarefa', (this.tarefas_obrigatorias = 0));
        this.$emit('next');
      }
    },
    adicionar () {
      this.clear = true;
      this.btnedit = false;
      this.dialog = !this.dialog;
    },
    formatDate (date) {
      if (!date) return null;

      const [year, month, day] = date.split('-');
      return `${day}/${month}/${year}`;
    },
    pickHabilidade (dado) {
      console.log('pick');
      this.habilidades = [];
      this.atualizar = false;
      for (let index = 0; index < dado.length; index++) {
        this.habilidades = this.habilidades.concat(dado[index].habilidades);
      }
      this.habilidades = this.habilidades.filter((ab, index, self) =>
        index === self.findIndex((t) => (
          t.id === ab.id
        ))
      )
      this.atualizar = true;
      // console.log('aqui', this.habilidades)
    },
    criteriosSelecionados (value, close = true) {
      if (close) {
        this.dialog = false;
      }
      this.salvandoCriterio[this.i] = {
        habilidades: value,
        title: this.tarefatitulo,
        description: this.tarefadescricao,
        evidencia_foco: true,
        number: this.i
      };
      this.tarefatitulo = '';
      this.tarefadescricao = '';
      console.log('salvando cri', this.salvandoCriterio);
      this.i = this.i + 1;
      this.dialog = false;
    },
    editarSolicitacao (value, index) {
      console.log(value, index);
      this.editHabil = value;
      this.tarefatitulo = value.title;
      this.tarefadescricao = value.description;
      this.ident = index;
      console.log(index);
      this.btnedit = true;
      this.dialog = true;
    },
    editAtual (value) {
      // console.log(value)
      this.salvandoCriterio[this.ident] = {
        habilidades: value,
        title: this.tarefatitulo,
        description: this.tarefadescricao,
        evidencia_foco: true
      };
      this.tarefatitulo = '';
      this.tarefadescricao = '';
      console.log('salvando cri', this.salvandoCriterio);
      this.editHabil = [];
      this.dialog = false;
    },
    closeDialog () {
      this.dialog = false
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Projetos/CadastroSteps/Step4.vue